module.exports = __webpack_public_path__ + "static/Hero-Banner-Logistics-1-0df16898ab047d2390c76eeedf645050.jpg";